import css from './single-class.scss';

const GROUP_NAME = 'name';
const COURSE_NAME = 'courseName';
const STUDENT_NAME = 'fullName';
const ACTIVITY_POINTS = 'points.activityPoints';
const SKILL_POINTS = 'points.skillQuestsPoints';
const LIVE_POINTS = 'points.livePoints';
const TOTAL_POINTS = 'points.total';
const BRONZE = 'certificateDetails.bronze';
const SILVER = 'certificateDetails.silver';
const GOLD = 'certificateDetails.gold';
const SIGN_INS = 'signIns';
const TIME_ONLINE = 'timeOnline';
const TOTAL_ACTIVITY_POINTS = 'activityPoints';
const TOTAL_SKILL_POINTS = 'skillQuestsPoints';
const TOTAL_LIVE_POINTS = 'livePoints';

const headerSort = { sortAs: 'nested', sortDir: 'desc' };
const nestedSort = { sortAs: 'number' };

const SINGLE_CLASS_PARTICIPATION_TABLE_CONFIG = {
    cols: [
        {
            id: GROUP_NAME,
            name: '', // this is set to teacher name in SingleClass component
            truncate: true,
            onClick: null, // this is set to load group view for class view only in SingleClass component
            classes: css['group-name'],
            sort: null // this is set to sort for class view only in SingleClass component
        },
        {
            id: COURSE_NAME,
            name: 'Points - Activity',
            trucate: true,
            colSpan: 7,
            classes: css['course-name'],
            sort: { sortAs: 'nested' }
        },
        {
            id: 'SKILL QUESTS POINTS',
            name: 'Points - Skill',
            headerOnly: true,
            sort: headerSort
        },
        /*
         * These cols will show only in the header
         * The nested data config will handle displaying these values for each group
         */
        {
            id: 'LIVE POINTS',
            name: 'Header - LivePoints',
            headerOnly: true,
            sort: headerSort
        },
        {
            id: 'TOTAL POINTS',
            name: 'Points - Total',
            headerOnly: true,
            sort: headerSort
        },
        {
            id: 'BRONZE',
            name: 'Label - Bronze',
            headerOnly: true,
            sort: headerSort
        },
        {
            id: 'SILVER',
            name: 'Label - Silver',
            headerOnly: true,
            sort: headerSort
        },
        {
            id: 'GOLD',
            name: 'Label - Gold',
            headerOnly: true,
            sort: headerSort
        }
    ],
    nestedData: {
        id: 'studentUsageDetails',
        cols: [
            {
                id: STUDENT_NAME,
                truncate: true,
                onClick: () => null, // this is set to load student view in SingleClass component
                classes: css['student-name']
            },
            {
                id: ACTIVITY_POINTS,
                sort: nestedSort
            },
            {
                id: SKILL_POINTS,
                sort: nestedSort
            },
            {
                id: LIVE_POINTS,
                sort: nestedSort
            },
            {
                id: TOTAL_POINTS,
                sort: nestedSort
            },
            {
                id: BRONZE,
                sort: nestedSort
            },
            {
                id: SILVER,
                sort: nestedSort
            },
            {
                id: GOLD,
                sort: nestedSort
            }
        ]
    },
    emptyDataMessage: 'No participation results found',
    defaultSort: null
};

const SINGLE_CLASS_USAGE_TABLE_CONFIG = {
    cols: [
        {
            id: SIGN_INS,
            name: 'Header - Sign-ins'
        },
        {
            id: TIME_ONLINE,
            name: 'Header - TimeOnline',
            transform: (row) => {
                const { hours, minutes } = row.timeOnline;
                return `${hours}h ${minutes}min`;
            }
        },
        {
            id: TOTAL_ACTIVITY_POINTS,
            name: 'Points - Activity'
        },
        {
            id: TOTAL_SKILL_POINTS,
            name: 'Points - Skill'
        },
        {
            id: TOTAL_LIVE_POINTS,
            name: 'Header - LivePoints'
        }
    ]
};

export {
    SINGLE_CLASS_PARTICIPATION_TABLE_CONFIG,
    SINGLE_CLASS_USAGE_TABLE_CONFIG,
    GROUP_NAME,
    STUDENT_NAME,
    COURSE_NAME
};



// WEBPACK FOOTER //
// ./containers/participation/single-class/single-class-constants.js